import animations from './elements/animations';
import menu from './elements/menu';
import burger from './elements/burger';
import subnavigation from './elements/subnavigation';
import map from './elements/map';
import calendar from './elements/calendar';
import contact from './elements/contact';
import form from './elements/form';
import roomslider from './elements/roomslider';

document.addEventListener('DOMContentLoaded', e => {
    animations();
    menu();
    burger();
    subnavigation();
    roomslider();
    map();
    calendar();
    contact();
    form();
});
